import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import LogbookSignatureModal from '../../LogbookAppIntegration/LogbookSignatureModal';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookCrewTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          staffs: {},
          approvals: [],
          approval: [],
          reason: '',
          pending_captain_acceptances: [],
          pending_report_action_id: null,
          email: '',
          password: '',
          showLogbookSignatureModal: false,
          signature_modal_title: '',
          signature_modal_subtitle: '',
          signature_modal_confirmation: '',
        };
        //Handlers
        this.reprove = this.reprove.bind(this);
        this.handleApprove = this.handleApprove.bind(this);
        this.handlePendingAcceptance = this.handlePendingAcceptance.bind(this);
        this.acceptPendingAction = this.acceptPendingAction.bind(this);
        this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
        this.handleSignatureModalCancel = this.handleSignatureModalCancel.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.staffs !== 'undefined' && newProps.staffs !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            staffs: newProps.staffs,
          });
        }

        if(typeof newProps.approvals[4] !== 'undefined' && newProps.approvals[4] !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[4],
            approval: newProps.approvals[4][0],
          });
        }

        if (typeof newProps.pending_captain_acceptances !== 'undefined' && newProps.pending_captain_acceptances !== null && this.state.loaded === 1) {
          this.setState({
            pending_captain_acceptances: newProps.pending_captain_acceptances,
          });
        }
      }

      handleApprove() {
        if (!this.state.approval || typeof this.state.approval.id === 'undefined') {
          return;
        }

        if (this.state.pending_captain_acceptances.length > 0) {
          if (typeof this.props.handleAlert === 'function') {
            this.props.handleAlert('Não é possível aprovar, existem ações de manutenção pendentes de aceitação do comandante.', 'error', 'open');
          }
          return;
        }

        this.props.approve(this.state.approval.id, this.state.approval.type);
      }

      handlePendingAcceptance(actionId) {
        if (!actionId) {
          return;
        }

        if (this.props.logbook_app == 1) {
          this.setState({
            pending_report_action_id: actionId,
            signature_modal_title: 'Você tem certeza de que deseja integrar e registrar a aceitação de Comandante no Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true,
          });
          return;
        }

        this.setState({
          pending_report_action_id: actionId,
          email: '',
          password: '',
        }, this.acceptPendingAction);
      }

      handleLogbookSignatureSubmit(credentials) {
        this.setState({
          email: credentials.email,
          password: credentials.password,
          showLogbookSignatureModal: false,
        }, this.acceptPendingAction);
      }

      acceptPendingAction() {
        if (!this.state.pending_report_action_id) {
          return;
        }

        this.props.handleAlert('', '', 'open');
        const datasave = {
          report_action_id: this.state.pending_report_action_id,
          email: this.state.email,
          password: this.state.password,
        };

        const header = this.refs.request_api.header('application/json');
        const self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/reporte/acao/aceitar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({
                pending_report_action_id: null,
                email: '',
                password: '',
                signature_modal_title: '',
                signature_modal_subtitle: '',
                signature_modal_confirmation: '',
              });
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      handleSignatureModalCancel() {
        this.setState({
          showLogbookSignatureModal: false,
          pending_report_action_id: null,
          email: '',
          password: '',
          signature_modal_title: '',
          signature_modal_subtitle: '',
          signature_modal_confirmation: '',
        });
      }

      reprove(event) {
        event.preventDefault();
        var self = this;
        if(window.confirm('Tem certeza que deseja reprovar?')) {
          self.props.handleAlert('', '', 'open');
          var datasave = {
            aircraft_logbook_approval_id: self.state.reproved_id,
            reason: self.state.reason,
          };
          var header = self.refs.request_api.header('application/json');
          var url = '/aeronave/diario/aprovacao/reprovar';
          Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({reason: null, reproved_id: null, modal: false});
              self.props.updateData(responseJson);
            }).catch((error) => {
              console.error(error);
            });
          });
        }
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />

      {this.state.pending_captain_acceptances.length > 0 &&
        <div className="alert alert-warning" role="alert">
          Existe(m) ação(ões) de manutenção pendente(s) de aceitação do comandante em diário(s) anterior(es). Realize as aprovações antes de prosseguir.
        </div>
      }

      {this.state.pending_captain_acceptances.length > 0 &&
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Maintenance Actions Pending Captain Acceptance</caption>
            <thead>
              <tr>
                <th className="text-center vcenter">Item</th>
                <th className="text-center vcenter">Base</th>
                <th className="text-center vcenter">Action</th>
                <th className="text-center vcenter">System</th>
                <th className="text-center vcenter">Next Mnt Type</th>
                <th className="text-center vcenter">Date</th>
                <th className="text-center vcenter">Hrs Next Mnt</th>
                <th className="text-center vcenter">RII</th>
                <th className="text-center vcenter">Tools</th>
                <th className="text-center vcenter">Executor</th>
                <th className="text-center vcenter">Inspector</th>
                <th className="text-center vcenter">RTS</th>
                <th className="text-center vcenter">RTS Approval</th>
                <th className="text-center vcenter">Captain</th>
                <th className="text-center vcenter">Captain Acceptance</th>
              </tr>
            </thead>
            <tbody id="pending_report_actions">
              {this.state.pending_captain_acceptances.map(function(action) {
                const systemName = action.system_name || (action.aircraft_logbook_report && action.aircraft_logbook_report.system ? action.aircraft_logbook_report.system.name : '');
                const nextMaintenanceName = action.next_maintenance_intervention_type_name || (action.aircraft_logbook_report && action.aircraft_logbook_report.next_maintenance_intervention_type ? action.aircraft_logbook_report.next_maintenance_intervention_type.type : '');
                const baseAbbreviation = (action.base && action.base.abbreviation) ? action.base.abbreviation : action.base_name;

                return (
                  <tr className="text-center" key={action.id}>
                    <td>{action.item}</td>
                    <td>{baseAbbreviation}</td>
                    <td>{action.action}</td>
                    <td>{systemName}</td>
                    <td>{nextMaintenanceName}</td>
                    <td>{action.date_str}</td>
                    <td>{action.flight_hours_next_maintenance_intervention_str}</td>
                    <td>{action.mandatory_inspection_str}</td>
                    <td>{action.tools_str}</td>
                    <td>{action.executor_user_name}</td>
                    <td>{action.inspector_user_name}</td>
                    <td>{action.rts_user_name}</td>
                    <td>{action.rts_approval_date_str}</td>
                    <td>{action.captain_user_name}</td>
                    <td>
                      {action.captain_acceptance_date === null ?
                        <button onClick={() => self.handlePendingAcceptance(action.id)} className="btn btn-success btn-sm button-inline">
                          <i className="fa fa-check"></i>
                        </button>
                        :
                        action.captain_acceptance_date_str
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      }

      <div className="row">
        <div className="col-md-1 text-center">
          {
          (self.state.approval.status === 1) ?
              <button className="btn btn-success" disabled><i className="fa fa-check"></i></button>
          : (self.state.approval.status === 2) ?
              <button className="btn btn-danger" disabled><i className="fa fa-close"></i></button>
          :
            <div>
              <button onClick={() => {self.setState({reproved_id: self.state.approval.id, modal: true, type: self.state.approval.type})}} className="btn btn-danger button-inline"><i className="fa fa-close"></i></button>
              <button onClick={self.handleApprove} className="btn btn-success button-inline"><i className="fa fa-check"></i></button>
            </div>
          }
        </div>
        <div className="col-md-7">
          <h3 className="page-title pull-left">Captain Acceptance&nbsp;
          </h3>
          <div className="clearfix"></div>
        </div>
        <div className="col-md-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <caption>Approval</caption>
              <thead>
                <tr className="text-center">
                  <th>User</th>
                  <th>Status</th>
                  <th>Approval Date</th>
                </tr>
              </thead>
              <tbody id="crew_approvals">
                {self.state.approvals.map(function(k) {
                    var approval = k;
                    return(
                      <tr className="text-center" key={approval.id}>
                        {
                          (typeof approval.user_id !== 'undefined' && approval.user_id !== null) ?
                          <td>{approval.user_name}</td>
                          :
                          <td></td>
                        }
                        <td>{approval.status_str}</td>
                        <td>{approval.approval_date_str}</td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <hr/>
      <div className='row'>
        <div className='col-md-12'>
          <h3 className="page-title pull-left">Crew</h3>
          <div className="clearfix"></div>
          <hr/>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Crew Name</th>
                  <th>Function</th>
                  <th>ANAC Code</th>
                  <th>Arrival Time</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(self.state.staffs).map(function(k)
                {
                  var staff = self.state.staffs[k];
                  return(
                    <tr className="text-center" key={staff.id}>
                      <td>{staff.staff.name}</td>
                      <td>{staff.duty.anac_code}</td>
                      <td>{staff.staff.canac}</td>
                      <td>{staff.arrival_str}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <hr/>
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">Justificativa de reprovação</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal: false})}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.reprove}>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Razão da reprovação:</label>
                <input type="text" name="reason" className="form-control" placeholder="Justifique a sua reprovação" value={this.state.reason} onChange={this.handleChange.bind(this, 'reason')} />
              </div>
              <div className="col-md-6 form-group">
                <button type="submit" className="btn btn-danger btn-block btn-inline"><i className="fa fa-fw fa-close"></i> Reprovar diário de bordo</button>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_captain_login: false})}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
      <LogbookSignatureModal
        show={this.state.showLogbookSignatureModal}
        onHide={this.handleSignatureModalCancel}
        onSubmit={this.handleLogbookSignatureSubmit}
        title={this.state.signature_modal_title}
        subtitle={this.state.signature_modal_subtitle}
        confirmation={this.state.signature_modal_confirmation}
      />
    </div>
    );
  }
}

export default AircraftLogbookCrewTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookCrewTab.js